<div class="mat-elevation-z8">
  <table
    mat-table
    matSort
    [dataSource]="dataSource"
    (matSortChange)="announceSortChange($event)"
  >
    <ng-container matColumnDef="code">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by code"
      >
        Code
      </th>
      <td mat-cell *matCellDef="let element">{{ element.code }}</td>
    </ng-container>

    <ng-container matColumnDef="nom">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by nom"
      >
        Nom
      </th>
      <td mat-cell *matCellDef="let element">{{ element.nom }}</td>
    </ng-container>

    <ng-container matColumnDef="modePaiement">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by mode de paiement"
      >
        Mode Paie. (der.com.)
      </th>
      <td mat-cell *matCellDef="let element">{{ element.modePaiement }}</td>
    </ng-container>

    <ng-container matColumnDef="nbreUtilisateur">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by mode de nombre utilisateurs"
      >
        Utilisateurs
      </th>
      <td mat-cell *matCellDef="let element">{{ element.nbreUtilisateur }}</td>
    </ng-container>

    <ng-container matColumnDef="soldeCredits">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by solde"
      >
        Solde crédits
      </th>
      <td mat-cell *matCellDef="let element">{{ element.soldeCredits }}</td>
    </ng-container>

    <ng-container matColumnDef="reappoAuto">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by reappoAuto"
      >
        Réappo. auto
      </th>
      <td mat-cell *matCellDef="let element">
        <div class="d-flex align-items-center">
          <mat-icon *ngIf="element.reappoAuto" [color]="'accent'">
            check_circle
          </mat-icon>
          <span class="ms-1"> {{ element.reappoAuto }}</span>
        </div>
      </td>
    </ng-container>

    <ng-container matColumnDef="dateDerniereCommande">
      <th
        mat-header-cell
        mat-sort-header
        *matHeaderCellDef
        sortActionDescription="Sort by dateCommande"
      >
        Dernière commande
      </th>
      <td mat-cell *matCellDef="let element">
        {{ element.dateDerniereCommande }}
      </td>
    </ng-container>

    <!-- Symbol Column -->
    <ng-container matColumnDef="action">
      <th mat-header-cell *matHeaderCellDef>action</th>
      <td mat-cell *matCellDef="let element">
        <button mat-mini-fab color="primary" [matMenuTriggerFor]="menu">
          <mat-icon>more_horiz</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
          <button mat-menu-item (click)="onCreditOrder()">
            Commander crédits
          </button>
          <button mat-menu-item (click)="onDeleteCredit()">
            Supprimer des crédits
          </button>
          <button mat-menu-item>Historique des commandes</button>
          <button mat-menu-item>Gérer les utilisateurs</button>
        </mat-menu>
      </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
  </table>

  <mat-paginator
    [pageSizeOptions]="[5, 10, 20]"
    showFirstLastButtons
    aria-label="Select page of periodic elements"
  >
  </mat-paginator>
</div>
